module.exports = __webpack_public_path__ + "img/user-avatar.a4354870.png";